<template>
  <div style="width:100%">
    <div class="select-box" @click="showPicker">
      <template>
        <div v-if="selectedDisplay" class="van-ellipsis">{{selectedDisplay}}</div>
        <div v-else class="placeholder">{{placeholder}}</div>
      </template>
      <van-icon class="select-box-icon" :name="iconName" color="#c4c4c4" />
    </div>
    <van-popup v-model="isShowPicker" position="bottom" :style="{height:'40%'}" get-container="body">
      <van-picker 
        show-toolbar 
        :columns="columns" 
        :default-index="defaultIndex" 
        @cancel="onCancel"
        @change="onChange"
        @confirm="onConfirm"
        @click.native="onClick"
        />
    </van-popup>
  </div>
</template>

<script>
import { closest } from '@/utils/dom'
export default {
  name: 'QSelect',
  props: {
    value: [String, Number],
    // 格式： [{label: 'zhangsan', value: 'qy10003232'}]
    items: {
      type: Array,
      default() {
        return [];
      }
    },
    placeholder: {
      type: String
    }
  },
  computed: {
    columns() {
      return this.items.map(item => item.label);
    },
    iconName() {
      return this.isShowPicker ? 'arrow-up' : 'arrow-down'
    }
  },
  watch: {
    value: {
      handler(val, oldVal) {
        this.handleValueChange(val);
      },
      immediate: true
    }
  },
  data() {
    return {
      isShowPicker: false,
      defaultIndex: 0,
      selectedValue: undefined,
      selectedDisplay: '',
      lastValue: undefined,
      inited: false
    }
  },
  methods: {
    showPicker() {
      if (this.isShowPicker) {
        this.isShowPicker = false;
        return;
      }

      if (this.columns.length) {
        // 设置选中值
        this.isShowPicker = true;
      }
    },
    getValueByLabel(label) {
      const target = this.items.find(item => item.label === label);
      if (target) {
        return target.value;
      }
      return undefined;
    },
    getLabelByValue(value) {
      const target = this.items.find(item => item.value === value);
      return target ? target.label : '';
    },
    onCancel() {
      this.isShowPicker = false;
    },
    onChange(picker, value, index) {
      this.selectedValue = this.getValueByLabel(value);
    },
    onClick(evt) {
      // 是否点击选项item
      const clickedColumn = closest(evt.target, '.van-picker-column__item');
      if (!clickedColumn) {
        return;
      }

      this.$nextTick(() => {
        if (this.selectedValue === undefined) {
          this.selectedValue = this.items[0].value;
        }
        this.emitValue();
      })
    },
    emitValue(label) {
      // this.selectedDisplay = label ? label : this.getLabelByValue(this.selectedValue);
      this.$emit('input', this.selectedValue);

      if (this.selectedValue !== this.lastValue) {
        this.$emit('change', this.selectedValue);
      }
      this.lastValue = this.selectedValue;
      
      this.isShowPicker = false;
    },
    onConfirm(label) {
      this.selectedValue = this.getValueByLabel(label);
      this.emitValue(label);
    },
    setDefaultIndex(value) {
      const initIndex = this.items.findIndex(item => item.value === value);
      this.defaultIndex = initIndex > -1 ? initIndex : 0;
    },
    handleValueChange(val) {
      this.selectedValue = val;
      this.lastValue = val;
      this.setDefaultIndex(val);
      this.selectedDisplay = this.getLabelByValue(val);
    }
  }
}
</script>

<style lang="stylus" scoped>
.select-box
  box-sizing border-box
  display flex
  align-items center
  justify-content space-between
  padding 5px 10px
  height 32px
  border 1px solid #c4c4c4
  border-radius 3px
  font-size 14px
  color #666666
  div
    flex 1
    display inline-block
    min-width 35px
  .placeholder
    color #c9c9c9
  &-icon
    margin-left 10px
</style>